import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// `window` augmentations for script-tag globals now live in src/globals.d.ts so the spec
// build sees them too — see the note there.

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
